

export function LoadingSpinner({ label = "Loading", compact = false }: { label?: string; compact?: boolean }) {
    return (
        <div className="flex h-full w-full flex-col items-center justify-center gap-4">
            <div className={`${compact ? 'h-14 w-14' : 'h-24 w-24'} animate-spin rounded-full border-4 border-emerald-100 border-b-emerald-800`}></div>
            {label && <p className="text-sm font-semibold text-emerald-950">{label}</p>}
        </div>
    );
}
